import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'author-svg',
  templateUrl: './author-svg.component.html',
  styleUrls: ['./author-svg.component.css'],
})
export class AuthorSvgComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
